<div #help class="help-container popup-container">
  <h2 class="title-help center-text">{{ 'help.title' | translate }}</h2>
  <p class="content-help center-text">{{ 'help.needhelp' | translate }}</p>
  <p class="content-help center-text">{{ 'help.contact' | translate }}</p>
  <div class="help-informations">
    <div class="informations-line">
      <mat-icon>mail</mat-icon>
      <a class="support-text" href="mailto:support@music-work.com">support@music-work.com</a>
    </div>
    <div class="informations-line" id="line-2">
      <mat-icon>call</mat-icon>
      <a class="support-text" href="tel:+33 (0)1 76 46 05 42">+33 (0)1 76 46 05 42</a>
    </div>
  </div>
</div>
